import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Observable} from "rxjs";
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ReportTask} from "../../model/archive/report-task";
import {ApiFileResponse} from "../../model/api/api-file-response";
import {ReportTaskLoadRequest} from "../../model/archive/report-task-load-request";
import {ReportTotalResidual} from "../../model/archive/report-total-residual";
import {DateTime} from "luxon";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class ReportTotalResidualService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public list(selectedDate: string): Observable<ApiValidation<ReportTotalResidual[]>> {
    return this.post(CrystalclearArchiveBackUrl.POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_LIST_FOR_DATE, new SimpleRequest(selectedDate));
  }

  public adjust(selectedDate: string, forceReportTotalResiduals: ReportTotalResidual[]): Observable<ApiValidation<any>> {
    return this.post(CrystalclearArchiveBackUrl.POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ADJUST, forceReportTotalResiduals,
      {selectedDate: selectedDate});
  }

  public isDailyReportEnabled(): Observable<ApiValidation<boolean>> {
    return this.post(CrystalclearArchiveBackUrl.POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ISDAILYREPORTENABLED,
      {});
  }

  public enableDailyReport(enable: boolean): Observable<ApiValidation<boolean>> {
    return this.post(CrystalclearArchiveBackUrl.POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ENABLEDAILYREPORT,{},
      {enable: enable});
  }

  public sendReport(toAll: boolean): Observable<ApiValidation<string[]>> {
    return this.post(CrystalclearArchiveBackUrl.POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_SENDREPORT, {},
      {toAll: toAll});
  }

}
